export enum UploadFileType {
  FormData = 'FormData',
  Banner = 'Banner',
  Content = 'Content',
  FileContent = 'FileContent',
  SpeakerContent = 'SpeakerContent',
  ProfilePicture = 'ProfilePicture',
  Logo = 'Logo',
  LogoContent = 'LogoContent',
  VideoContent = 'VideoContent',
  Attachment = 'Attachment',
  Certificate = 'Certificate',
}

export interface UploadFileModel {
  id: string;
  file: File;
  type: UploadFileType;
}
